import {
  VisitorAction,
  VisitorActionType,
  VisitorPageHit,
  VisitorEngagements
} from "../types";
import StoreContainer from "./StoreContainer";

export default class VisitorActionStore {
  addEngagement(engagementId: string, agentName: string) {
    const engagements = this.getEngagements();

    if (engagements[engagementId]) {
      return;
    }

    engagements[engagementId] = { agentName, startedAt: new Date() };
    StoreContainer.LocalStorageStore.set("engagements", engagements);
  }

  addPageHit() {
    const pageHits = this.getPageHits();
    const fullUrl = window.parent.window.location.toString();
    const truncatedUrl = fullUrl.substr(0, 150);

    if (pageHits.length > 20) {
      pageHits.shift();
    }

    pageHits.push({
      url: truncatedUrl,
      viewedAt: new Date()
    });

    StoreContainer.LocalStorageStore.set("pageHits", pageHits);
  }

  getActions(): VisitorAction[] {
    const actions: VisitorAction[] = [];
    const pageHits = this.getPageHits();
    const engagements = this.getEngagements();

    pageHits.forEach((pageHit) => {
      actions.push({
        ActionType: VisitorActionType.PageHit,
        When: pageHit.viewedAt,
        Value: pageHit.url
      });
    });

    Object.keys(engagements).forEach((engagementId) => {
      actions.push({
        ActionType: VisitorActionType.EngagementRequest,
        When: engagements[engagementId].startedAt,
        Value: engagements[engagementId].agentName
      });
    });

    return actions;
  }

  private getPageHits(): VisitorPageHit[] {
    return StoreContainer.LocalStorageStore.get("pageHits") || [];
  }

  private getEngagements(): VisitorEngagements {
    return StoreContainer.LocalStorageStore.get("engagements") || {};
  }

  hasChatted(): boolean {
    return Object.keys(this.getEngagements()).length > 0;
  }
}
